module.exports = __webpack_public_path__ + "img/dashboard-users-coach.95fb9ba2.png";